import { fileUrl } from "@/lib/api";
import { Linkedin } from "lucide-react";

// Renders published leadership profiles. Photos preserve aspect ratio (object-cover, no distortion).
export function LeadershipSection({ overline, heading, records }) {
  if (!records || records.length === 0) return null;
  return (
    <section data-testid="about-leadership-section" className="bg-cream">
      <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6">
        {overline && <div className="overline text-center text-saffron">{overline}</div>}
        {heading && <h2 className="mt-2 text-center font-display text-3xl font-bold text-charcoal sm:text-4xl">{heading}</h2>}
        <div className={`mt-12 grid gap-8 ${records.length === 1 ? "max-w-sm mx-auto grid-cols-1" : records.length === 2 ? "max-w-3xl mx-auto grid-cols-1 sm:grid-cols-2" : "sm:grid-cols-2 lg:grid-cols-3"}`}>
          {records.map((p) => (
            <div key={p.id} data-testid={`leader-${p.id}`} className="hover-lift overflow-hidden rounded-2xl border border-gold/25 bg-white">
              {p.photo
                ? <div className="aspect-[4/5] overflow-hidden bg-charcoal/5"><img src={fileUrl(p.photo)} alt={p.photo_alt || p.name} style={{ objectPosition: p.photo_focal || "50% 30%" }} className="h-full w-full object-cover" /></div>
                : <div className="flex aspect-[4/5] items-center justify-center bg-forest/10 font-display text-4xl text-forest">{(p.name || "?").charAt(0)}</div>}
              <div className="p-6">
                <div className="flex items-start justify-between gap-2">
                  <div>
                    <h3 className="font-display text-xl font-semibold text-charcoal">{p.name}</h3>
                    {p.designation && <div className="font-accent text-xs font-semibold uppercase tracking-wide text-saffron">{p.designation}</div>}
                  </div>
                  {p.linkedin_url && <a href={p.linkedin_url} target="_blank" rel="noopener noreferrer nofollow" aria-label={`${p.name} on LinkedIn`} data-testid={`leader-linkedin-${p.id}`} className="text-charcoal/60 hover:text-[#0a66c2]"><Linkedin className="h-4 w-4" /></a>}
                </div>
                {p.bio_short && <div className="mt-3 text-sm leading-relaxed text-muted-foreground" dangerouslySetInnerHTML={{ __html: p.bio_short }} />}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
